export enum EntityTypes {
  CAMERA = 'CAMERA',
  INTERSECTION_GROUP = 'INTERSECTION_GROUP',
  INTERSECTION = 'INTERSECTION',
  LOCATION_GROUP = 'LOCATION_GROUP',
  LOCATION = 'LOCATION',
  GATE_SYSTEM = 'GATE_SYSTEM',
  GATE = 'GATE',
  SIGN = 'SIGN',
  TRAVEL_TIME = 'TRAVEL_TIME',
  EVENT = 'EVENT',
  ALERT = 'ALERT',
  COUNT_SITE = 'COUNT_SITE',
  TOLLING_POINT = 'TOLLING_POINT',
  CORRIDOR = 'CORRIDOR',
  TUNNEL_FAN = 'TUNNEL_FAN',
  DPS_INTERFACE = 'DPS_INTERFACE',
  NVR = 'NVR',
}
